import React, { forwardRef, useMemo } from "react";
import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import PageRecord from "models/view-models/page-record";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import { t } from "utilities/localization-utils";

export interface LogoMenuItemProps extends ButtonProps {
    page: PageRecord;
    onClick: () => void;
}

const CSS_CLASS_NAME = "c-page-context-menu";

const LogoMenuItem = forwardRef<HTMLButtonElement, LogoMenuItemProps>(
    (props, ref) => {
        const { page, onClick } = props;
        const { can } = usePageActionPermission(page);
        const canManageLogo = useMemo(
            () => can(PageAction.ManageCustomLogo),
            [can]
        );

        return (
            <>
                {canManageLogo && (
                    <Button
                        cssClassName={`${CSS_CLASS_NAME}__button`}
                        onClick={onClick}>
                        <Icon type={Icons.Image} />
                        <span className={`${CSS_CLASS_NAME}__button-text`}>
                            {t("logo")}
                        </span>
                    </Button>
                )}
            </>
        );
    }
);

export default LogoMenuItem;
